export const LANGUAGE_LIST = {
    french:"fr-FR",
    english:"en-UK",
    }